import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import PageProposal from '../views/pageProposal.vue';
import PageGrb from '../views/pageGrb.vue';
import PageSem from '../views/pageSem.vue';

import Admin from '../views/admin.vue';
import AdminUser from '../views/adminusercenter.vue';
import Core from '../views/core.vue';
import DataOwner from '../views/owner.vue';
import Fileda from '../views/fileda.vue';
import ProposalData from '../views/proposal.vue';
import GrbData from '../views/grbdata.vue';
import SemData from '../views/semdata.vue';
import SysPam from '../views/syspam.vue';
import VAV from '../views/vav.vue';
import DownloadStat from '../views/downstat.vue';
import SummaryStat from '../views/sumstat.vue';
import SummaryUserData from '../views/sumusrdata.vue';
import SummaryYearlyData from '../views/summaryyearlydata.vue';
import SummaryPositionData from '../views/summarypositiondata.vue';
import SummaryTargetTop from '../views/summarytargettop.vue';

import UserV from '../views/userv.vue';
import DatAuth from '../views/datauth.vue';
import DatapropAuth from '../views/datapropauth.vue';
import UserMg from '../views/usermg.vue';
import DevAuthor from '../components/DevAuthor.vue' ;

import UsappByPm from '../views/usappbypm.vue';//项目经理审核页
// import UsappTutorvernon from '../views/usapptutorvernon.vue';//导师(非核心组)审核页
import UsappbkByPm from '../views/usappbkbypm.vue';//批量申请，项目经理审核页

import UsappTutorverin from '../views/usapptutorverin.vue';//导师(核心组)审核页
import UsappTutorvernon from '../views/usapptutorvernon.vue';//导师(非核心组)审核页
import UsappChiefver from '../views/usappchiefver.vue';//首席审核页
import UsappPartnersver from '../views/usapppartnersver.vue';//合作人审核页
import UsappDatamanagerver from '../views/usappdatamanagerver.vue';//数据管理员审核页
import UsappChargehandver from '../views/usappchargehandver.vue';//组长副组长审核页

import UsappbkTutorverin from '../views/usappbktutorverin.vue';//批量申请 导师(核心组)审核页
import UsappbkTutorvernon from '../views/usappbktutorvernon.vue';//批量申请 导师(非核心组)审核页
import UsappbkChiefver from '../views/usappbkchiefver.vue';//批量申请 首席审核页
import UsappbkPartnersver from '../views/usappbkpartnersver.vue';//批量申请 合作人审核页(导师参与)
import UsappbkPanerver from '../views/usappbkpanerver.vue';//批量申请 合作人审核页（无导师）
import UsappbkDatamanagerver from '../views/usappbkdatamanagerver.vue';//批量申请 数据管理员审核页
import UsappbkChargehandver from '../views/usappbkchargehandver.vue';//批量申请 组长副组长审核页
import UsappbkRefuse from '../views/usappbkrefuse.vue';//批量审核 拒绝数据审阅页
import UsappbkOk from '../views/usappbkok.vue';//批量审核 同意数据审阅页

import InfoObs from '../views/infoobs.vue';//观测详情页
import InfoTarget from '../views/infotarget.vue';//目标详情页
import InfoProposal from '../views/infoproposal.vue';//提案详情页
import InfoQuicklook from '../views/infoquicklook.vue';//快视页

import DataRelease from '../views/datareleas.vue';//文件发布页
import DataUpgrade from '../views/datauppk.vue';//数据升级包维护
import DataUpdatePackageDown from '../components/DataUpPackageDown.vue';//数据升级包下载页面
//管理导航页
import AdminIndex from '../views/adminindex.vue';
//用户中心三个页面
import UsrcenInfo from '../views/usrInfo.vue';//用户信息页面
import ApplyList from '../views/usrapplylist.vue';//我的-申请数据页面
import DownloadList from '../views/usrdllist.vue';//我的-下载数据页面


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/proposal',
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/proposal',
    name: 'proposal',
    component: PageProposal,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/grb',
    name: 'grb',
    component: PageGrb,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/sem',
    name: 'sem',
    component: PageSem,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappbypm/:id/:statecode',
    name: 'usappbypm',
    component: UsappByPm,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappbkbypm/:batch',
    name: 'usappbkbypm',
    component: UsappbkByPm,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usapptutorverin/:id/:statecode',
    name: 'usapptutorverin',
    component: UsappTutorverin,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usapptutorvernon/:id/:statecode',
    name: 'usapptutorvernon',
    component: UsappTutorvernon,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappchiefver/:id/:statecode',
    name: 'usappchiefver',
    component: UsappChiefver,
    props: true,
  },
  {
    path: '/usapppartnersver/:id/:statecode/',
    name: 'usapppartnersver',
    component: UsappPartnersver,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappdatamanagerver/:id/:statecode/',
    name: 'usappdatamanagerver',
    component: UsappDatamanagerver,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappchargehandver/:id/:statecode/:email',
    name: 'usappchargehandver',
    component: UsappChargehandver,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },

  {
    path: '/usappbktutorverin/:batch',
    name: 'usappbktutorverin',
    component: UsappbkTutorverin,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappbktutorvernon/:batch',
    name: 'usappbktutorvernon',
    component: UsappbkTutorvernon,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappbkchiefver/:batch',
    name: 'usappbkchiefver',
    component: UsappbkChiefver,
    props: true,
  },
  {
    path: '/usappbkpartnersver/:batch',
    name: 'usappbkpartnersver',
    component: UsappbkPartnersver,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappbkpanerver/:batch',
    name: 'usappbkpanerver',
    component: UsappbkPanerver,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappbkdatamanagerver/:batch',
    name: 'usappbkdatamanagerver',
    component: UsappbkDatamanagerver,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappbkchargehandver/:batch',
    name: 'usappbkchargehandver',
    component: UsappbkChargehandver,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappbkrefuse/:batch',
    name: 'usappbkrefuse',
    component: UsappbkRefuse,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/usappbkok/:batch',
    name: 'usappbkok',
    component: UsappbkOk,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/infoobs/:id',
    name: 'infoobs',
    component: InfoObs,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/infotarget/:id',
    name: 'infotarget',
    component: InfoTarget,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/infoproposal/:id',
    name: 'infoproposal',
    component: InfoProposal,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/infoquicklook/:id',
    name: 'infoquicklook',
    component: InfoQuicklook,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/DataUpPackageDown/:id',
    name: 'DataUpPackageDown',
    component: DataUpdatePackageDown,
    props: true,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/devauth',
    name: 'devauth',
    component: DevAuthor,
    meta: {
      auth: false,
      admin: 0,
    },
  },
  {
    path: '/UserCenter',
    name: 'UserCenter',
    component: AdminUser,
    children: [
      {
        path: 'usrceninfo',
        name: 'usrceninfo',
        component: UsrcenInfo,
        meta: {
          auth: true,
          admin: 0,
        },
      },
      {
        path: 'applylist',
        name: 'applylist',
        component: ApplyList,
        meta: {
          auth: true,
          admin: 0,
        },
      },
      {
        path: 'dllist',
        name: 'dllist',
        component: DownloadList,
        meta: {
          auth: true,
          admin: 0,
        },
      },
    ],
  },

  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    children: [
      {
        path: 'index',
        name: 'index',
        component: AdminIndex,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'core',
        name: 'core',
        component: Core,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'owner',
        name: 'owner',
        component: DataOwner,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'filedata',
        name: 'filedata',
        component: Fileda,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'proposal',
        name: 'admin-proposal',
        component: ProposalData,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'datarelease',
        name: 'Data-Release',
        component: DataRelease,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'dataupgrade',
        name: 'Data-Upgrade',
        component: DataUpgrade,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'grbdata',
        name: 'grbdata',
        component: GrbData,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'semdata',
        name: 'semdata',
        component: SemData,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'syspam',
        name: 'syspam',
        component: SysPam,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'vav',
        name: 'vav',
        component: VAV,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'userv',
        name: 'userv',
        component: UserV,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'datauth',
        name: 'datauth',
        component: DatAuth,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'datapropauth',
        name: 'datapropauth',
        component: DatapropAuth,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'downloadstat',
        name: 'downloadstat',
        component: DownloadStat,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'summarystat',
        name: 'summarystat',
        component: SummaryStat,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'summaryuserdata',
        name: 'summaryuserdata',
        component: SummaryUserData,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'summaryyearlydata',
        name: 'summaryyearlydata',
        component: SummaryYearlyData,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'summarypositiondata',
        name: 'summarypositiondata',
        component: SummaryPositionData,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'summarytargettop',
        name: 'summarytargettop',
        component: SummaryTargetTop,
        meta: {
          auth: true,
          admin: 1,
        },
      },
      {
        path: 'usermg',
        name: 'usermg',
        component: UserMg,
        meta: {
          auth: true,
          admin: 1,
        },
      },       
    ],
  },
  
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve((to, from, next) => {
  if (store.state.userInfo) {
    if (store.state.userInfo.isadmin < to.meta.admin) {
      next({path: '/'});
    } else {
      next();
    }
  } else {
    store.dispatch('getUserInfo').then((userInfo) => {
      if (userInfo) {
        if (userInfo.isadmin < to.meta.admin) {
          next({path: '/'});
        } else {
          next();
        }
      } else {
        if(to.meta.auth) {
          next({path: '/'});
        } else {
          next();
        }
      }
    }).catch();
  }
});

export default router;
